import { Dispatch, SetStateAction, createContext, useContext } from "react";

export interface ActiveElement {
  drag: boolean;
  setDrag: Dispatch<SetStateAction<boolean>>;
  placement: { time: number; duration: number };
  setPlacement: Dispatch<SetStateAction<{ time: number; duration: number }>>;
  transition: number;
  setTransition: Dispatch<SetStateAction<number>>;
  wasDrag: boolean;
  setWasDrag: Dispatch<SetStateAction<boolean>>;
  trim: boolean;
  setTrim: Dispatch<SetStateAction<boolean>>;
  allowClick: boolean;
  setAllowClick: Dispatch<SetStateAction<boolean>>;
}

const defaultContextValue: ActiveElement = {
  drag: false,
  setDrag: () => {},
  placement: { time: -1, duration: -1 },
  setPlacement: () => {},
  transition: 0,
  setTransition: () => {},
  wasDrag: false,
  setWasDrag: () => {},
  trim: false,
  setTrim: () => {},
  allowClick: true,
  setAllowClick: () => {}
};

export const ActiveElementContext = createContext<ActiveElement>(defaultContextValue);

export const useActiveElementContext = () => {
  const activeElementContext = useContext(ActiveElementContext);

  if (!activeElementContext) throw new Error("useActiveElementContext must be used with a TimelineContext");

  return activeElementContext;
};
